import React, { useEffect, useState } from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Contactform from '../Mencontact/Contactform'

import Footer from '../Footer/Main'
import EditJobForm from '../EditJobForm/Main'
import { getStrapiData } from '../../api.controller'

function Main() {

  const [data, setData] = useState();
  useEffect(() => {
    getStrapiData("add-job-page").then(response => {
      console.log(response);
      setData(response.data);
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <Header />
        <Breadcrumb data={data} subtitle="Home" title="Edit Job" />
        <EditJobForm />
        <Footer />
      </div>
    </div>
  )
}

export default Main